import { connect } from 'react-redux'
import ThumbnailList from './ThumbnailList.jsx'
import { fetchMedia } from 'redux/mediaList/actions'
import { getMediaList } from 'redux/mediaList/selectors'
import {
    getMediaIndex,
    getMediaCount
} from 'redux/navigation/selectors'
import {
    getMediaBatchSize,
    getMediaThreshold,
    getFetchMediaDebounceWait,
} from 'redux/configuration/selectors'
import { isFetchedMedia } from 'redux/fetchingMedia/selectors'
import { getGroupTitle } from 'redux/group/selectors'
import { closeThumbnailsNavigation } from 'redux/thumbnails/actions'

const mapStateToProps = state => ({
    mediaList: getMediaList(state),
    index: getMediaIndex(state),
    isFetchedMedia: ({ index }) => isFetchedMedia(state, index),
    count: getMediaCount(state),
    batchSize: getMediaBatchSize(state),
    threshold: getMediaThreshold(state),
    debounceWait: getFetchMediaDebounceWait(state),
    groupTitle: getGroupTitle(state),
})

const mapDispatchToProps = (dispatch, getState) => ({
    fetchMedia: ({ startIndex, stopIndex }) => dispatch(fetchMedia(startIndex, stopIndex)),
    close: () => {
        dispatch(closeThumbnailsNavigation())
    }
})

export const ThumbnailListContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ThumbnailList)
